module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-beijing.689e6193.jpg";